import React from "react";
import { Route, Switch } from "react-router-dom";

import { Routing } from "../../../../core/routing";
import { ROUTES } from "../../../../routes";
import { ProductHistoryDetailPage } from "./detail_page";
import { ProductHistoryListPage } from "./list_page";

export const ProductHistoryMainPage: React.FC = () => {
  return (
    <Switch>
      <Route path={ROUTES.productHistory} exact>
        <ProductHistoryListPage />
      </Route>

      <Route path={Routing.generateDetailRoute(ROUTES.productHistory)}>
        <ProductHistoryDetailPage />
      </Route>
    </Switch>
  );
};
